/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

const Home = lazy(() => import('pages/Home'));
const ListPage = lazy(() => import('pages/ListPage'));
const InnerPage = lazy(() => import('pages/InnerPage'));
const SearchPage = lazy(() => import('pages/SearchPage'));
const SitemapPage = lazy(() => import('pages/Sitemap'));

const Routes: React.FC = () => (
    <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/search" component={SearchPage} />
        <Route exact path="/sitemap" component={SitemapPage} />
        <Route exact path="/:listName" component={ListPage} />
        <Route exact path="/:listName/:id" component={InnerPage} />
        <Route exact path="/preview/:id" component={InnerPage} />
    </Switch>
);

export default Routes;
